export const FETCH_EMBER_PATHS = 'FETCH_EMBER_PATHS';
export const SET_EMBER_PATHS = 'SET_EMBER_PATHS';
export const FETCH_EMBER_PRACTICES_BY_PATHS = 'FETCH_EMBER_PRACTICES_BY_PATHS';
export const FETCH_LEGEND_PATH = 'FETCH_LEGEND_PATH';
export const FETCH_LEGEND_PATH_BY_PRACTICES = 'FETCH_LEGEND_PATH_BY_PRACTICES';
export const FETCH_EMBER_PRACTICES = 'FETCH_EMBER_PRACTICES';
export const FETCH_EMBER_PRACTICES_BY_ID = 'FETCH_EMBER_PRACTICES_BY_ID';
export const SET_EMBER_PRACTICES = 'SET_EMBER_PRACTICES';
export const SET_EMBER_CURRENT_PRACTICE = 'SET_EMBER_CURRENT_PRACTICE';
export const FETCH_EMBER_HPA_TAGS = 'FETCH_EMBER_HPA_TAGS';
export const SET_EMBER_HPA_TAGS = 'SET_EMBER_HPA_TAGS';
